// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.013 4C7.44 4.79 4.76 8.072 4.76 12c0 4.518 3.546 8.182 7.92 8.182 1.982 0 3.793-.75 5.183-1.994-4.457-.895-7.822-4.95-7.822-9.815 0-1.568.35-3.052.972-4.373zM3 12C3 6.477 7.335 2 12.68 2h.777c.417 0 .66.46.418.79l-.486.666a8.318 8.318 0 0 0-1.588 4.917c0 4.516 3.543 8.178 7.916 8.181h.77c.416.001.659.46.417.79l-.485.666C18.653 20.433 15.844 22 12.68 22 7.335 22 3 17.523 3 12z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceMoon;
